import React from 'react';
import '../styles/About.css';
import Values from '../components/Values';
import aboutHero from '../assets/images/AboutUs.jpg';
import aboutWhoWeAre from '../assets/images/About - Who We Are.jpg';
import directorImg from '../assets/images/About-Sadeq.jpg';
import FAQAccordion from '../components/FAQAccordion';
import ScrollDownArrow from '../components/ScrollDownArrow';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero" style={{ backgroundImage: `url(${aboutHero})` }}>
        <div className="about-hero-overlay"></div>
        <div className="about-hero-content">
          <h1 className="about-hero-title">About Us</h1>
          <p className="about-hero-subtitle">Committed To Excellence In Dubai Real Estate</p>
        </div>
        <ScrollDownArrow targetSelector=".about-who-we-are" />
      </section>

      {/* Who We Are Section */}
      <section className="about-who-we-are">
        <div className="about-who-container">
          <div className="about-who-image">
            <img src={aboutWhoWeAre} alt="Who We Are" />
          </div>
          <div className="about-who-text">
            <h2>Who We Are</h2>
            <h3>Committed To Excellence</h3>
            <p>
              At ABBASS Global Properties, we specialize in educating, guiding, and connecting international buyers with premium real estate opportunities in Dubai. As part of the ABBASS Group, our expertise stems from years of experience across various sectors, providing clients and their families with a foundation of trust, transparency, and world-class service. We aim to make the process of purchasing property seamless and rewarding.
            </p>
            <p>
              Whether you are a seasoned investor seeking high-growth opportunities or looking to own a luxury home, ABBASS Global Properties is your dedicated partner. We offer an exceptional level of information to support your decision-making and help you realize the perfect property for you. We are proud to maintain a highly Personalised client service model, a commitment to developing exceptional client experiences, and a passion for Dubai's real estate market.
            </p>
          </div>
        </div>
      </section>

      {/* Our Values Section (reuse component) */}
      <Values />

      {/* Meet The Managing Director Section */}
      <section className="about-director-section">
        <div className="about-director-container">
          <div className="about-director-image director-img-hover">
            <img src={directorImg} alt="Sadeq Abbass - Managing Director" />
          </div>
          <div className="about-director-text">
            <h2 style={{ color: 'var(--about-gold)', fontWeight: 800 }}>Meet The Managing Director</h2>
            <h3 style={{ fontWeight: 700 }}>Sadeq Abbass | Managing Director</h3>
            <p className="about-director-role" style={{ fontWeight: 600 }}>Visionary And Strategic Leader</p>
            <p>
              Sadeq Abbass is a real estate and finance expert with a proven track record in global investments. As the founder of ABBASS Global Properties, and the broader ABBASS Group, Sadeq Specialises in connecting international investors with high-yield opportunities in Dubai's booming real estate market.
            </p>
            <p>
              With a strong background in finance, real estate, and business, Sadeq has built a reputation for integrity, results, and client relationships. His dedication to success and his network of relationships with Dubai's most reputable developers and advisors positions ABBASS Global Properties as a trusted partner for investors in Dubai and beyond.
            </p>
            <p>
              Sadeq's vision is to simplify global property investment by providing expert guidance, exclusive opportunities, and long-term wealth-building solutions. His mission is clear—when clients succeed in real estate, ABBASS Global Properties succeeds with them.
            </p>
            <a href="https://www.linkedin.com/in/sadeqabbass/" target="_blank" rel="noopener noreferrer" className="about-director-linkedin gold-btn" aria-label="Get to know Sadeq on LinkedIn">
              Get to know Sadeq
            </a>
          </div>
        </div>
      </section>

      <FAQAccordion />
      
    </div>
  );
};

export default About; 